import { createAction } from '@reduxjs/toolkit';
import { SmoEnvironment } from '../../../../Models/Smo/SmoEnvironment';
import { UserRun } from '../../../../Models/User/UserRun';
import { UserWidgetSettings } from '../../../../Models/User/UserWidgetSettings';
import { Optional } from '../../../../Utils/Types';

const setSettings = createAction<UserWidgetSettings>('WIDGET_SET_SETTINGS');
const setRun = createAction<Optional<UserRun>>('WIDGET_SET_RUN');
const setEnvironment = createAction<SmoEnvironment>('WIDGET_SET_ENVIRONMENT');

const connectWidget = createAction<string>('WIDGET_CONNECT_WIDGET');
const observeSettings = createAction('WIDGET_OBSERVE_SETTINGS');
const observeRun = createAction('WIDGET_OBSERVE_RUN');
const observeEnvironment = createAction('WIDGET_OBSERVE_ENVIRONMENT');
const disconnectWidget = createAction('WIDGET_STOP_SERVER_EVENT_OBSERVATION');

export default {
  observeSettings,
  setSettings,
  setRun,
  setEnvironment,
  connectWidget,
  observeRun,
  observeEnvironment,
  disconnectWidget
};
